import React from 'react';
import styled from 'styled-components';
import { SiteFooter } from '@99designs/site-navigation';
import { Site } from '@99designs/site-navigation/lib/Site';

const SiteFooterOverride = styled.div`
    ul {
        margin-left: 0;
    }
`;

interface props {
    site: Site;
}

// HACK: Currently the <BaseCss /> component sets a margin left on ul elements
// which shifts the site footer list items to the right.
// This is a temporary workaround.
export default function SiteFooterStyleOverride({ site }: props) {
    return (
        <SiteFooterOverride>
            <SiteFooter site={site} />
        </SiteFooterOverride>
    );
}
